module.exports = __webpack_public_path__ + "img/1-in-3.928a9d2d.svg";